import { fetchMe } from "store/user/actions"
import { loadLocalConfig } from "components/LocalConfigPersist/index."

export const initApp = () => (dispatch) => {
    dispatch({ type: "INITIALIZE_APP" })
    dispatch({ type: "LOCAL_CONFIG_LOAD", payload: loadLocalConfig() })
    dispatch(fetchMe())
}

export const introConfirmed = () => (dispatch) => {
    dispatch({ type: "INTRO_CONFIRMED" })
}

export const locationAsked = () => (dispatch) => {
    dispatch({ type: "LOCATION_PERMISSION_ASKED" })
}

export const cameraAsked = () => (dispatch) => {
    dispatch({ type: "CAMERA_PERMISSION_ASKED" })
}